import api from '../config/api';
import { getApiData, parseApiError } from './apiUtils';

export const fetchFicha = (usuarioId) => {
  if (!usuarioId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/ficha_obtener.php', { usuario_id: usuarioId })
    .then((response) => getApiData(response, 'No se pudo cargar la ficha.'))
    .then((data) => data.ficha || null)
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const saveFicha = (solicitanteId, usuarioId, ficha) => {
  if (!solicitanteId || !usuarioId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/ficha_guardar.php', { solicitante_id: solicitanteId, usuario_id: usuarioId, ficha })
    .then((response) => getApiData(response, 'No se pudo guardar la ficha.'))
    .then((data) => data.ficha || ficha)
    .catch((error) => {
      throw parseApiError(error);
    });
};
